import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Truck } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";

export default function AdminDrivers() {
  const [drivers, setDrivers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });

  const load = () => api.get("/drivers").then((r) => setDrivers(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/drivers", form); toast.success("Driver created"); setOpen(false); setForm({ name: "", email: "", phone: "", password: "" }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  const remove = async (d) => {
    if (!window.confirm(`Remove driver ${d.name}?`)) return;
    try { await api.delete(`/drivers/${d.id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <h2 className="font-heading font-bold text-xl sm:text-2xl text-[#1C2826]">Drivers</h2>
        <Button onClick={() => setOpen(true)} className="bg-[#2F5233] hover:bg-[#1F3D24] text-white rounded-lg" data-testid="new-driver-btn">
          <Plus className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Add driver</span>
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {drivers.map((d) => (
          <div key={d.id} className="bg-white border border-[#E1E5DF] rounded-lg p-5" data-testid={`driver-${d.id}`}>
            <div className="flex items-start justify-between">
              <div className="h-11 w-11 rounded-full bg-[#2F5233]/10 flex items-center justify-center">
                <Truck className="h-5 w-5 text-[#2F5233]" />
              </div>
              <Button size="sm" variant="ghost" onClick={() => remove(d)}><Trash2 className="h-4 w-4 text-[#E74C3C]" /></Button>
            </div>
            <div className="mt-3 font-heading font-semibold text-[#1C2826]">{d.name}</div>
            <div className="text-sm text-[#4A5D5A]">{d.email}</div>
            <div className="text-sm text-[#738380]">{d.phone || "—"}</div>
          </div>
        ))}
        {drivers.length === 0 && <div className="col-span-full p-10 text-center text-[#738380] bg-white rounded-lg border border-[#E1E5DF]">No drivers yet</div>}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>New driver</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Full name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="driver-name" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="driver-email" /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="driver-phone" /></div>
            <div><Label>Password</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="driver-password" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={save} className="bg-[#2F5233] hover:bg-[#1F3D24] text-white" data-testid="driver-save">Create</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
